import { register, findAll, find } from '../../../Javascript/Utils.js'

const Accordion = el => {
  const componentPrefix = 'oAccordionAccordionItem'
  const accordionItems = findAll(`.${componentPrefix}`, el)
  const collapseOthers = el.dataset.collapseothers
  accordionItems.forEach((accordionItem, index) => {
    const toggler = find(`.${componentPrefix}-Header`, accordionItem)
    toggler.addEventListener('click', () => {
      if (collapseOthers) {
        accordionItems.forEach((accordionItemInner, innerIndex) => {
          if (innerIndex !== index) {
            accordionItemInner.classList.remove(`${componentPrefix}--Open`)
          }
        })
      }
      accordionItem.classList.toggle(`${componentPrefix}--Open`)
    })
  })
}

register('Accordion', Accordion)
